import React from 'react'
import { useSiteMetadata } from '../hooks/useSiteMetadata'

export const Seo = ({ title, description, pathname, children }) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    siteUrl: defaultURL,
  } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    url: `${defaultURL}${pathname || ``}`,
  }

  return (
    <>
      <script
        async
        src='https://www.googletagmanager.com/gtag/js?id=G-HFFHGQGPGP'
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-HFFHGQGPGP')`,
        }}
      ></script>
      <title>{seo.title}</title>
      <meta name='description' content={seo.description} />
      {children}
    </>
  )
}
